import { apiFetch } from "../utils/apiFetch";
import React, { useEffect, useState } from "react";
import { FaCircleCheck, FaCircleExclamation, FaHouse, FaRotateRight, FaSpinner } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router";

const SubscriptionVerfication = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const payment = state?.payment;
  const [status, setStatus] = useState("verifying");
  const [error, setError] = useState("");
  const [errorCode, setErrorCode] = useState(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    const verify = async () => {
      setStatus("verifying");
      setError("");
      setErrorCode(null);
      try {
        if (!payment?.razorpay_payment_id || !payment?.razorpay_subscription_id || !payment?.razorpay_signature) {
          throw new Error("No payment details were provided.");
        }

        const response = await apiFetch(`${process.env.API_URL}/api/subscriptions/verify`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",

          },
          body: JSON.stringify(payment),
          signal: controller.signal,
        });
        const data = await response.json();
        if (!response.ok) {
          const verificationError = new Error(data.message || "Could not verify payment.");
          verificationError.code = data.code;
          throw verificationError;
        }
        if (!controller.signal.aborted) setStatus("success");
      } catch (err) {
        if (controller.signal.aborted) return;
        setError(err.message || "Could not verify payment.");
        setErrorCode(err.code || null);
        setStatus("error");
      }
    };
    verify();
    return () => controller.abort();
  }, [payment, attempt]);

  return (
    <main className="min-h-dvh bg-gray-50 flex items-center justify-center px-6 py-10">
      <div className="w-full max-w-md text-center flex flex-col items-center gap-5">
        <div role="status" aria-live="polite" className="flex flex-col items-center gap-4">
          {status === "verifying" ? (
            <>
              <FaSpinner aria-hidden="true" className="h-12 w-12 animate-spin text-gray-700" />
              <h1 className="text-2xl font-bold text-gray-950">Verifying payment</h1>
            </>
          ) : status === "success" ? (
            <>
              <FaCircleCheck aria-hidden="true" className="h-14 w-14 text-green-600" />
              <h1 className="text-2xl font-bold text-gray-950">Payment Successful</h1>
            </>
          ) : (
            <>
              <FaCircleExclamation aria-hidden="true" className="h-12 w-12 text-red-600" />
              <h1 className="text-2xl font-bold text-gray-950">Unable to verify payment</h1>
              <p className="text-gray-600 break-words">{error}</p>
            </>
          )}
        </div>
        {status === "error" && payment && errorCode !== "PAYMENT_ALREADY_PROCESSED" && (
          <button type="button" onClick={() => setAttempt((value) => value + 1)} className="flex items-center justify-center gap-2 min-h-11 px-5 py-2 border border-gray-300 rounded text-gray-900 hover:bg-gray-100">
            <FaRotateRight aria-hidden="true" /> Retry verification
          </button>
        )}
        {status !== "verifying" && (
          <button type="button" onClick={() => navigate("/", { replace: true })} className="flex items-center justify-center gap-2 min-h-11 px-5 py-2 rounded bg-gray-950 text-white hover:bg-gray-800">
            <FaHouse aria-hidden="true" /> Go to home
          </button>
        )}
      </div>
    </main>
  );
};

export default SubscriptionVerfication;
